import React, {useEffect} from "react";
import useCreateTest from "../hooks/useCreateTest";
import {FormProvider, useForm} from "react-hook-form";
import {IFormCreateTestSchool} from "../components/_interfaces";
import {yupResolver} from "@hookform/resolvers/yup";
import {testTrainingSchema} from "../components/_schemas";
import Box from "@mui/material/Box";
import AddTestButton from "../components/AddTestButton";
import TestConfigMultipleClassrooms from "../components/TestConfigMultipleClassrooms";
import SuccessView from "../components/SuccesView";
import PageTitle from "../../../../shared/ui/PageTitle";

const CustomPageTitle = () => (
    <PageTitle>Generează teste școlare pentru mai multe clase</PageTitle>
);

const CreateTestMultipleClassrooms = () => {

    const methods = useForm<IFormCreateTestSchool>({
        resolver: yupResolver(testTrainingSchema),
    });

    const testForm = useCreateTest({
        type: "school",
        multipleClassrooms: true,
        setError: methods.setError,
        clearErrors: methods.clearErrors,
    });

    const {
        createTestData,
        errorMessage,
        setErrorMessage,
        successMessage,
        isFormValid,
        submitTest,
        resetFormData,
    } = testForm;

    useEffect(() => {
        if (Object.keys(methods.formState.errors).length === 0) {
            setErrorMessage("");
        }
    }, [createTestData]);

    if (successMessage) {
        return (
            <>
                <CustomPageTitle />
                <SuccessView
                    message={successMessage}
                    onReset={resetFormData}
                />
            </>
        );
    }

    return (
        <>
            <CustomPageTitle />
            <Box width="100%">
                <FormProvider {...methods}>
                    <form onSubmit={methods.handleSubmit(submitTest)} noValidate>
                        <Box mb={{xs: 5, md: 3}}>
                            <TestConfigMultipleClassrooms
                                type="school"
                                subjects={testForm.subjects}
                                grades={testForm.grades}
                                createTestData={createTestData}
                                setClassroomsHandler={testForm.setClassroomsHandler}
                                getSelectedClassrooms={testForm.getSelectedClassrooms}
                                setSelectedStudentsHandler={testForm.setSelectedStudentsHandler}
                                handleSelectChange={testForm.handleSelectChange}
                                handleInputChange={testForm.handleInputChange}
                                setSubjectHandler={testForm.setSubjectHandler}
                                setGradeHandler={testForm.setGradeHandler}
                                setSelectedCategoriesHandler={testForm.setSelectedCategoriesHandler}
                                handleTestStartDate={testForm.handleTestStartDateMultipleClassrooms}
                                setTeacherHandler={testForm.setTeacherHandler}
                                setSelectedClassroomsStudentsHandler={testForm.setSelectedClassroomsStudentsHandler}
                                loading={testForm.loading}
                                errors={methods.formState.errors}
                                tags={testForm.tags}
                                setSelectedStandardsHandler={testForm.setSelectedStandardsHandler}
                            />
                        </Box>
                        {isFormValid && (
                            <AddTestButton errorMessage={errorMessage} />
                        )}
                    </form>
                </FormProvider>
            </Box>
        </>

    );
}

export default CreateTestMultipleClassrooms;